var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.classObject},[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }